@if (isUnderMaintenance) {
	<app-maintenance />
} @else {
	<app-alert-stack />
	<router-outlet />
}
